import React from 'react';
import NavigationBar from '../../navigationbar';
import Footer from '../../footer';
import './bilder.css';

import baumfrau from '../../assets/Kunst/Baumfrau.jpg';
import baumfrau2 from '../../assets/Kunst/Baumfrau2.jpg';
import abstakt from '../../assets/Kunst/abstakt.jpg';
import blume from '../../assets/Kunst/blume.jpg';
import blumen from '../../assets/Kunst/blumen.jpg';
import ermutigen from '../../assets/Kunst/ermutigen.jpg';
import ermutigen2 from '../../assets/Kunst/ermutigen2.jpg';
import ermutigen3 from '../../assets/Kunst/ermutigen3.jpg';
import sonnenuntergang from '../../assets/Kunst/sonnenuntergang.jpg';

function Bilder() {
  const images = [
    { src: baumfrau, alt: "Baumfrau" },
    { src: baumfrau2, alt: "Baumfrau 2" },
    { src: abstakt, alt: "Abstrakt" },
    { src: blume, alt: "Blume" },
    { src: blumen, alt: "Blumen" },
    { src: ermutigen, alt: "Ermutigen" },
    { src: ermutigen2, alt: "Ermutigen 2" },
    { src: ermutigen3, alt: "Ermutigen 3" },
    { src: sonnenuntergang, alt: "Sonnenuntergang" }
  ];

  const [selectedImage, setSelectedImage] = React.useState(null);

  const openModal = (image) => {
    setSelectedImage(image);
  };

  const closeModal = () => {
    setSelectedImage(null);
  };

  // Close modal when clicking outside the image
  const handleModalClick = (e) => {
    if (e.target.classList.contains('modal-overlay')) {
      closeModal();
    }
  };

  // Prevent right-click context menu on images
  const preventRightClick = (e) => {
    e.preventDefault();
    return false;
  };

  // Prevent drag and drop
  const preventDragStart = (e) => {
    e.preventDefault();
    return false;
  };

  // Prevent mobile long-press context menu
  const preventLongPress = (e) => {
    e.preventDefault();
    return false;
  };

  // Handle touch events to prevent context menu
  const handleTouchStart = (e) => {
    // Prevent default to avoid context menu
    if (e.touches.length > 1) {
      e.preventDefault();
    }
  };

  const handleTouchEnd = (e) => {
    e.preventDefault();
  };

  // Close modal with Escape key
  React.useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape' && selectedImage) {
        closeModal();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [selectedImage]);

  return (
    <>
        <NavigationBar/>
        <div className='bilder-page-wrapper'>
          <section className='bilder-header'>
            <h1>Kunst & Bilder</h1>
          </section>

          <section className='bilder-content'>
            <div className='bilder-description'>
              <p>
                Möchtest du ein ganz persönliches Kunstwerk erwerben, das dein Zuhause oder einen anderen Raum in deinem Leben mit genau der Energie füllt, die du dir wünscht, vielleicht auch deinem liebsten Spruch zeigt?<br/>
                Dann schreib <a href="/kontakt" >mir</a> gerne.<br/>
                Ich gestalte ganz individuell verschiedene Bilder, auf Papier oder Leinwand, mal realistisch, mal abstrakt.
              </p>
            </div>

            <div className='bilder-gallery'>
              {images.map((image, index) => (
                <div key={index} className='gallery-item' onClick={() => openModal(image)}>
                  <img 
                    src={image.src} 
                    alt={image.alt}
                    className='gallery-image'
                    onContextMenu={preventRightClick}
                    onDragStart={preventDragStart}
                    onTouchStart={handleTouchStart}
                    onTouchEnd={handleTouchEnd}
                    onTouchMove={preventLongPress}
                    onTouchCancel={preventLongPress}
                    style={{ WebkitTouchCallout: 'none', WebkitUserSelect: 'none' }}
                    draggable={false}
                  />
                  {/* Multiple copyright overlays */}
                  {/* <div className='copyright-overlay copyright-top-left'>
                    © Herznah
                  </div>
                  <div className='copyright-overlay copyright-top-right'>
                    © Herznah
                  </div>
                  <div className='copyright-overlay copyright-bottom-left'>
                    © Herznah
                  </div>
                  <div className='copyright-overlay copyright-bottom-right'>
                    © Herznah
                  </div>
                  <div className='copyright-overlay copyright-center'>
                    © Herznah
                  </div> */}
                  <div className='gallery-overlay'>
                    <span className='gallery-zoom-icon'>🔍</span>
                  </div>
                </div>
              ))}
            </div>
          </section>

          {/* Modal for large image view */}
          {selectedImage && (
            <div className='modal-overlay' onClick={handleModalClick}>
              <div className='modal-content'>
                <button className='modal-close' onClick={closeModal} aria-label="Schließen">
                  ×
                </button>
                <div className='modal-image-container'>
                  <img 
                    src={selectedImage.src} 
                    alt={selectedImage.alt}
                    className='modal-image'
                    onContextMenu={preventRightClick}
                    onDragStart={preventDragStart}
                    onTouchStart={handleTouchStart}
                    onTouchEnd={handleTouchEnd}
                    onTouchMove={preventLongPress}
                    onTouchCancel={preventLongPress}
                    style={{ WebkitTouchCallout: 'none', WebkitUserSelect: 'none' }}
                    draggable={false}
                  />
                  {/* Multiple modal copyright overlays */}
                  {/* <div className='modal-copyright-overlay modal-copyright-top-left'>
                    © Herznah - Alle Rechte vorbehalten
                  </div>
                  <div className='modal-copyright-overlay modal-copyright-top-right'>
                    © Herznah - Alle Rechte vorbehalten
                  </div>
                  <div className='modal-copyright-overlay modal-copyright-bottom-left'>
                    © Herznah - Alle Rechte vorbehalten
                  </div>
                  <div className='modal-copyright-overlay modal-copyright-bottom-right'>
                    © Herznah - Alle Rechte vorbehalten
                  </div>
                  <div className='modal-copyright-overlay modal-copyright-center'>
                    © Herznah - Alle Rechte vorbehalten
                  </div> */}
                </div>
                {/* <p className='modal-caption'>{selectedImage.alt}</p> */}
              </div>
            </div>
          )}

        </div>
        <Footer color="bilder"/>
    </>
  );
}

export default Bilder;